import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import FormAlert from "../../components/UI/FormAlert/FormAlert";
import TextSpinner from "../../components/UI/Spinner/TextSpinner";
import TableContribuinteSpf from "../../components/UI/Table/TableContribuinteSpf";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";

const ListaContribuinteAcaoFiscal = ({ formik, field, origem, documento }) => {
  const [inputContribuinte, setinputContribuinte] = useState("");
  const [dataListaContribuinte, setdataListaContribuinte] = useState([]);
  const [erroContribuinte, setErroContribuinte] = useState("");
  const [tipoBuscaContribuinte, setTipoBuscaContribuinte] = useState(0);
  const [fileAnexoContribuinte, setFileAnexoContribuinte] = useState({});

  const {
    request: requestContribuinte,
    data: dataContribuinte,
    errors: errorContribuinte,
    isLoading: loadContribuinte,
  } = useApiClient();

  const consultaContribuinte = useCallback(
    (identificador) => {
      const params = { listaContribuinte: identificador };
      if (params !== undefined && params.listaContribuinte !== undefined) {
        requestContribuinte(apiRoutes.fiscalizacao.procedimentoFiscal.consultaContribuinte, params);
      }
    },
    [requestContribuinte],
  );

  const consultaContribuinteAnexo = () => {
    if (fileAnexoContribuinte !== undefined) {
      requestContribuinte(apiRoutes.fiscalizacao.procedimentoFiscal.consultaContribuinteAnexo, fileAnexoContribuinte);
    }
  };

  useEffect(() => {
    if (dataContribuinte && !loadContribuinte) {
      if (dataContribuinte?.result?.encontrados?.length > 0) {
        dataContribuinte?.result?.encontrados?.forEach((item) => {
          if (
            !dataListaContribuinte.find(
              (x) =>
                x.sequencialPessoa === item.sequencialPessoa &&
                x.sequencialContribuinte === item.sequencialContribuinte,
            )
          ) {
            setdataListaContribuinte((curr) => curr.concat(item));
          }
        });
      }

      if (dataContribuinte?.result?.naoEncontrados?.length > 0) {
        setErroContribuinte(
          `Documentos não encontrados em nossa base de dados: ${dataContribuinte?.result?.naoEncontrados}`,
        );
      } else setErroContribuinte("");
    }

    if (errorContribuinte && !loadContribuinte) setErroContribuinte("");
  }, [requestContribuinte, dataContribuinte, errorContribuinte, loadContribuinte, dataListaContribuinte]);

  const onFileContribuinte = (event) => {
    event.preventDefault();

    // Get the file Id
    const { id } = event.target;
    // Create an instance of FileReader API
    const fileReader = new FileReader();
    // Get the actual file itself
    const file = event.target.files[0];
    fileReader.onload = () => {
      // After uploading the file
      // appending the file to our state array
      // set the object keys and values accordingly
      setFileAnexoContribuinte({
        file_id: id,
        name: file.name,
        type: file.type,
        file: fileReader.result,
      });
    };
    // reading the actual uploaded file
    fileReader.readAsDataURL(file);
  };

  useEffect(() => {
    if (documento) {
      consultaContribuinte(documento);
    }
  }, [documento, consultaContribuinte]);

  return (
    <>
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>Escolha a opção para informar o(s) contribuinte(s):</Form.Label>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} sm={2} md={2}>
          <Form.Check
            label="IE/CNPJ/CPF"
            name="opcaoContribuinte"
            type="radio"
            id="contribuinteIe"
            checked={tipoBuscaContribuinte === 0}
            onChange={() => setTipoBuscaContribuinte(0)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={10} md={10}>
          <Form.Control
            type="text"
            onChange={(event) => setinputContribuinte(event.target.value)}
            placeholder="Informe um ou mais IE/CNPJ/CPF"
            id="listaContribuinteInput"
            className="col-md-6"
            disabled={
              tipoBuscaContribuinte === 1 ||
              formik?.values?.numeroAberturaProcesso ||
              (formik?.values?.tipoOrigem !== "" && dataListaContribuinte.length > 0 && origem !== "OS")
            }
          />
          <p className="text-muted text-small small">
            (IE, CNPJ ou CPF devem ser delimitados por vírgula, sem espaço entre eles)
          </p>
          {loadContribuinte ? (
            <TextSpinner text="Buscando contribuinte..." />
          ) : (
            <Button
              disabled={
                tipoBuscaContribuinte === 1 ||
                formik?.values?.numeroAberturaProcesso ||
                (formik?.values?.tipoOrigem !== "" && dataListaContribuinte.length > 0 && origem !== "OS")
              }
              onClick={() => consultaContribuinte(inputContribuinte)}
            >
              Buscar
            </Button>
          )}
        </Form.Group>
      </Row>

      {origem !== undefined && origem !== "OS" && origem !== "OS-1" ? (
        <Row>
          <Form.Group as={Col} sm={2} md={2}>
            <Form.Check
              inline
              label="Arquivo"
              name="opcaoContribuinte"
              type="radio"
              id="contribuinteArquivo"
              checked={tipoBuscaContribuinte === 1}
              onChange={() => setTipoBuscaContribuinte(1)}
            />
          </Form.Group>
          <Form.Group as={Col} sm={10} md={10} disabled>
            <Form.File
              id="arquivoContribuinte"
              accept=".xlsx"
              onChange={() => onFileContribuinte}
              disabled={
                origem !== "OS"
                  ? tipoBuscaContribuinte === 0 ||
                    formik?.values?.numeroAberturaProcesso ||
                    (formik?.values?.tipoOrigem !== "" && dataListaContribuinte.length > 0)
                  : false
              }
            />
            <p className="text-muted text-small small">
              (Planilha .xlsx, formatação TEXTO com 3 colunas: IE ou CNPJ ou CPF, DATA INICIAL e DATA FINAL)
            </p>
            {loadContribuinte ? (
              <TextSpinner text="Buscando Contribuinte..." />
            ) : (
              <Button
                disabled={
                  tipoBuscaContribuinte === 0 ||
                  formik?.values?.numeroAberturaProcesso ||
                  (formik?.values?.tipoOrigem !== "" && dataListaContribuinte.length > 0)
                }
                onClick={() => consultaContribuinteAnexo(fileAnexoContribuinte)}
              >
                Buscar
              </Button>
            )}
          </Form.Group>
        </Row>
      ) : (
        ""
      )}

      <FormAlert formik={formik} data={dataContribuinte} errors={errorContribuinte} isLoading={loadContribuinte} />
      <Row hidden={erroContribuinte === ""}>
        <Form.Group as={Col} sm={12} md={12}>
          <Alert variant="danger" className="text-center">
            {erroContribuinte}
          </Alert>
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <TableContribuinteSpf
            data={dataListaContribuinte}
            formik={formik}
            field={field}
            selected={documento !== ""}
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default ListaContribuinteAcaoFiscal;
